import {Component, EventEmitter, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {__usernameOrEmail} from '../../../directives/validators/sts-conditional-email-validator.directive';
import {StsTenant} from '../../../models/sts-tenant.model';
import {StsPortalStatus} from '../../../models/sts-portal-status';
import {StsA360RegServicesService} from '../../../services/sts-a360-reg-services.service';
import {StsNotificationType} from '../../../models/sts-notification-type';
import { ActivatedRoute, Router} from '@angular/router';
import {StsTfaRegServiceService} from '../../../services/sts-tfa-reg-service.service';
import {StsPortalStatusService} from '../../../services/sts-portal-status.service';
import {StsTenantService} from '../../../services/sts-tenant.service';
import {StsNotification} from '../../../models/sts-notification.model';
import { StsCmsService } from '../../../services/sts-cms-service.service';
import { StsUserService } from '../../../services/sts-user.service';

@Component({
  selector: 'app-account-two-factor-verify',
  templateUrl: './account-two-factor-verify.component.html',
  styleUrls: ['./account-two-factor-verify.component.scss']
})
export class AccountTwoFactorVerifyComponent implements OnInit {


  public errors: StsNotification[] = [];
  public triggerValidateEmitter: EventEmitter<void> = new EventEmitter<void>();
  public submitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  public frm2: FormGroup;
  public tenantInfo: StsTenant = new StsTenant();
  public emailIsValid = true;
  public wantsToChangeEmail = false;
  public invalidCode = false;
  public tfaReference: string;
  public isRunOfAttempt: boolean;
  public counter: number;
  public channel: 'email' | 'phone';
  public communicationChannels = [];
  interval;
  description: string;
  hasBeenSent: boolean;
  sentEmailMessage: string;
  sentPhoneTextMessage: string;

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  constructor(private tfa: StsTfaRegServiceService,
              private regService: StsA360RegServicesService,
              private portalStatusService: StsPortalStatusService,
              private route: ActivatedRoute,
              private tenantService: StsTenantService,
              public fb: FormBuilder,
              private tntInfo: StsTenantService,
              private cmsService: StsCmsService ,
              private userService: StsUserService,
              private router: Router) {

    this.tenantService.getTenantSource().subscribe(tenant => {
      this.tenantInfo = tenant;

      this.portalStatusService.getPortalStatus().subscribe(
        (portalStatus: StsPortalStatus) => {
          // let isSelfRegFlow = portalStatus.isSelfRegFlow;
          // if (!isSelfRegFlow) {
          //   console.log("User attempting to execute 'set username' without permission! Redirecting to login.");
          //   this.router.navigateByUrl('/account/signin');
          //   return;
          // }
          this.tfaReference = portalStatus.tfaReference;
        });

      this.userService.getCommunicationChannels().subscribe(result => {
        if (result) {
          this.communicationChannels = result.communicationChannels;
        }

        this.resendEmail();
      });
    });

    this.frm2 = this.fb.group({
      trust: new FormControl(),
      code: new FormControl('',
        {
          validators: [ Validators.required] ,
          updateOn: 'submit'
        })
    }, { updateOn: 'submit' });


  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (params['channel']) {
        this.channel = params['channel'];
      } else {
        this.channel = 'email';
      }
    });
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  public triggerValidation(v) {
    this.frm2.controls['code'].updateValueAndValidity();
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  public gotoHome(): void {
    // this.router.navigateByUrl('/');
    document.location.href = '/account/signout';
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  isInvalidCode(): boolean {
    return this.frm2.controls['code'].invalid &&
      (this.frm2.controls['code'].dirty || this.frm2.controls['code'].touched);
  }


  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  resendEmail(): void {
    this.errors = [];
    this.triggerValidation('');
    this.isRunOfAttempt = false;
    this.hasBeenSent = false;

    // check if user is out of attempt to resent the code or not ?
    this.tfa.authMethods(this.tenantInfo.tfaPreferredMode, '').subscribe(resend => {
      if (!resend || (resend && resend.length === 0)) {
       // if there is no setting for the user then show a error message
        let e = new StsNotification();
        e.code = 'sts-auth-no-setting';
        e.level = StsNotificationType.Error;
        this.cmsService.getText(e.code).subscribe(res => {
          e.description = res ? res : 'There is no authentication setting for this user.';
          this.errors = [e];
        });

      } else if (resend && resend.length > 0) {
        if (resend[0].runOutOfAttempts) {
        // show error message
        this.counter = resend[0].nextAvailableAttemptInSeconds ? resend[0].nextAvailableAttemptInSeconds : 60;
        this.isRunOfAttempt = true;
        let e = new StsNotification();
        e.code = 'Dummy';
        //Dummy should never have label in CMS.We want to directly read from CMS but not from app-sts-cms-txt because Interpolation of counter doesnot work.
        e.level = StsNotificationType.Error;
        this.cmsService.getText('sts-resend-outof-attempt').subscribe(result => {
          let description = this.channel == 'email'
            ? 'You are running out of attempts to resend email to get a new code, please re-try after {{counter}} second.'
            : 'You are running out of attempts to resend SMS to get a new code, please re-try after {{counter}} second.';
          this.description = result ? result : description;
        });
        this.interval = setInterval(() => {
          if (this.counter > 0) {
            this.counter--;
            e.description = this.description.replace('{{counter}}', this.counter.toString());
            this.errors = [e];
          } else {
            this.isRunOfAttempt = false;
            this.errors = [];
          }
          clearInterval(this.interval);
        }, 1000);

      } else {
        this.sendValidationEmail();
      }
    }  // else {} --- TODO: if count is more than 1 then we need to show a dropdown box to let user to pick which way they gonna go
    });
  }


  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  onSubmitCode(): void {
    this.submitter.emit(false);
    this.triggerValidation('');
    this.invalidCode = false;
    if (this.frm2.valid) {
      this.submitter.emit(true);
      this.errors = [];
      this.tfa.validateCode(this.frm2.controls['code'].value,
        this.frm2.controls['trust'].value, true).subscribe(a => {
        this.submitter.emit(false);
        if (a.success) {
          document.location.href = '/';
        } else {
          let e = new StsNotification();
          e.code = 'sts-incorrect-verification-code-errors';
          e.level = StsNotificationType.Error;
          this.cmsService.getText(e.code).subscribe(res => {
            e.description = res ? res : 'submitted data contains errors.';
            this.errors = [e];
          });
        }
      });
    } else {
      let e = new StsNotification();
      e.code = 'sts-incorrect-verification-code-errors';
      e.level = StsNotificationType.Error;
      this.cmsService.getText(e.code).subscribe(res => {
        e.description = res ? res : 'submitted data contains errors.';
        this.errors = [e];
      });
    }
  }

  private mapToChannel(communicationChannel: string): string {
    switch (communicationChannel) {
      case 'EMAIL': return 'email'
      case 'SMS': return 'phone'
      default: return ''
    }
  }

  sendValidationEmail(): void {
    this.isRunOfAttempt = false;
    let communicationChannel = this.communicationChannels.find(x => this.mapToChannel(x.Type) == this.channel);
    let address = communicationChannel != null ? communicationChannel.Value : '';
    this.prepareConfirmationMessage(address);

    let destination = this.channel === 'email' ? this.tenantInfo.tfaPreferredMode : this.channel;
    this.tfa.sendValidationEmail(destination, address, true).subscribe(
        a => {
          if (a.success) {
            this.hasBeenSent = true;
            if (a['referenceNumber']) {
              this.tfaReference = a['referenceNumber'];
            }
            let e = new StsNotification();
            e.code = 'sts-verification-resent';
            e.level = StsNotificationType.Success;
            this.cmsService.getText(e.code).subscribe(res => {
              let description = this.channel == 'email' ? 'A new email was sent.' : 'A new SMS was sent.';
              e.description = res ? res : description;
              this.errors = [e];
            });
          } else {
            this.hasBeenSent = false;
            let e = new StsNotification();
            e.code = 'sts-verification-resent-failed';
            e.level = StsNotificationType.Error;
            this.cmsService.getText(e.code).subscribe(res => {
              let description = this.channel == 'email' ? 'A new email was not sent.' : 'A new SMS was not sent.';
              e.description = res ? res : description;
              this.errors = [e];
            });
          }
        });
  }

  private prepareConfirmationMessage(address: string) {
    this.cmsService.getText('sts-signup-step-3-validate-body-section').subscribe(res => {
      let message = res
        ? res
        : `We have sent an email to {{emailAddress}}. Please enter the verification code sent to you in the provided field below.`;

      this.sentEmailMessage = message.replace('{{emailAddress}}', this.maskEmail(address));
    });

    this.cmsService.getText('sts-signup-step-3-validate-body-section-phone').subscribe(res => {
      let message = res
        ? res
        : `We have sent a text to {{phoneNumber}}. Please enter the verification code sent to you in the provided field below.`;

      this.sentPhoneTextMessage = message.replace('{{phoneNumber}}', this.maskPhone(address));
    });
  }

  private maskPhone(phone: string): string {
    if (phone == undefined || phone.length == 0) {
      return '';
    }

    return phone.replace(/\d(?!\d{0,3}$)/g, 'x');
  }

  private maskEmail(email: string): string {
    if (email == undefined || email.length == 0)
    {
      return '';
    }

    let atIndex = email.indexOf('@');
    if (atIndex < 2)
    {
      return '';
    }

    let toReplace = email.substring(1, atIndex - 1);
    if (toReplace.length < 1)
    {
      return '';
    }

    let replaceWith = '';
    for (let i = 0; i < toReplace.length; i++)
    {
      replaceWith = replaceWith + 'x';
    }

    return email.replace(toReplace, replaceWith);
  }

}
